"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
/*
  AlternatingImageLayout is an alternating layout component that features a floating collage
    image on one side, and some text on the other.

  It differs from "ArticleTeasers" in that there is no floating "card."

  It is sort of a catch-all for any repeating, but non-article content on an index page.
*/
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const _theme_1 = require("@theme");
const _utils_1 = require("@utils"); // Component
var AlternatingImageLayout = function AlternatingImageLayout(_ref) {
    var url = _ref.url, onClick = _ref.onClick, imageUrl = _ref.imageUrl, _ref$orientation = _ref.orientation, orientation = _ref$orientation === void 0 ? 'left' : _ref$orientation, _ref$outlineImage = _ref.outlineImage, outlineImage = _ref$outlineImage === void 0 ? false : _ref$outlineImage, title = _ref.title, caption = _ref.caption, buttonLabel = _ref.buttonLabel, className = _ref.className;
    return /*#__PURE__*/ react_1.default.createElement(StyledMargin, {
        noGutter: true
    }, /*#__PURE__*/ react_1.default.createElement(Wrapper, Object.assign({
        orientation: orientation
    }, {
        className: "AlternatingImageLayoutWrapper " + className
    }), (url === null || url === void 0 ? void 0 : url.substr(0, 1)) === '/' && /*#__PURE__*/ react_1.default.createElement(atoms_1.LinkMask, {
        to: url
    }, title), (url === null || url === void 0 ? void 0 : url.substr(0, 1)) !== '/' && /*#__PURE__*/ react_1.default.createElement(atoms_1.LinkMask, {
        href: url,
        target: "_blank",
        rel: "noopener"
    }, title), /*#__PURE__*/ react_1.default.createElement(ImageWrapper, {
        outlineImage: outlineImage
    }, /*#__PURE__*/ react_1.default.createElement(LayoutImage, {
        src: imageUrl,
        widthClass: "float",
        alt: title
    })), /*#__PURE__*/ react_1.default.createElement(Copy, null, title && /*#__PURE__*/ react_1.default.createElement(Header, null, title), caption && /*#__PURE__*/ react_1.default.createElement(Caption, {
        dangerouslySetInnerHTML: {
            __html: caption
        }
    }), buttonLabel && /*#__PURE__*/ react_1.default.createElement(ButtonWrapper, null, /*#__PURE__*/ react_1.default.createElement(StyledButton, Object.assign({
        to: url
    }, {
        onClick: onClick
    }, {
        type: "black",
        shadow: true
    }), buttonLabel)))));
}; // Styling
/* We use smaller margin sizing for collages due to their negative white space. */
var StyledMargin = styled_components_1.default(atoms_1.Margin).withConfig({
    displayName: "AlternatingImageLayout__StyledMargin",
    componentId: "idkj2w-0"
})(["padding:32px 0;", "{padding:40px 0;}", "{padding:48px 0;}", "{padding:64px 0;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var Wrapper = styled_components_1.default.article.withConfig({
    displayName: "AlternatingImageLayout__Wrapper",
    componentId: "idkj2w-1"
})(["position:relative;display:flex;flex-direction:column;align-items:center;", "{flex-direction:", ";justify-content:space-between;}"], _utils_1.mediaQuery('tablet'), function (props) {
    return props.orientation == 'left' ? 'row-reverse' : 'row';
}); // Image
var ImageWrapper = styled_components_1.default.div.withConfig({
    displayName: "AlternatingImageLayout__ImageWrapper",
    componentId: "idkj2w-2"
})(["position:relative;flex:0 1 auto;align-self:center;width:100%;max-width:420px;height:auto;", " overflow:hidden;", "{flex:0 1 calc(45% - 20px);max-width:calc(45% - 20px);}", "{flex:0 1 calc(45% - 24px);max-width:calc(45% - 24px);}", "{flex:0 1 calc(45% - 32px);max-width:calc(45% - 32px);}"], function (props) {
    return props.outlineImage && 'border: 1px solid rgba(37, 35, 33, 0.64);';
}, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var LayoutImage = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(atoms_1.Image, props);
}).withConfig({
    displayName: "AlternatingImageLayout__LayoutImage",
    componentId: "idkj2w-3"
})(["width:100%;height:auto;transform:scale3d(1,1,1);transition:transform 0.8s ease-in-out;will-change:transform;", "{transform:scale3d(1,1,1);transition:opacity 0.5s ease-in-out,transform 0.8s ease-in-out;will-change:transform;", ":hover &{transform:scale3d(1.008,1.008,1);}}"], _utils_1.mediaQuery('tablet'), Wrapper); // Copy
var Copy = styled_components_1.default.div.withConfig({
    displayName: "AlternatingImageLayout__Copy",
    componentId: "idkj2w-4"
})(["flex:0 1 auto;position:relative;background:", ";width:100%;max-width:428px;padding:32px 24px;margin:0 auto;", "{flex:0 1 calc(55% - 20px);max-width:100%;padding:40px;margin:0;}", "{flex:0 1 calc(55% - 24px);padding:48px;}", "{flex:0 1 calc(55% - 32px);padding:48px 64px;}"], _theme_1.palette.ivory, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop')); // Text
var Header = styled_components_1.default.h3.withConfig({
    displayName: "AlternatingImageLayout__Header",
    componentId: "idkj2w-5"
})(["position:relative;display:inline;", " text-align:inherit;color:", ";text-shadow:0 1px 0 ", ",0 2px 0 ", ",-1px 1px 0 ", ",-1px 2px 0 ", ",1px 1px 0 ", ",1px 2px 0 ", ",-1px 0 0 ", ";transition:background-position 0.8s ease-in-out;will-change:background-position;", "{background-image:", ";background-repeat:no-repeat;background-size:100% 1px;background-position:-2000px calc(100% - 5px);", ":hover &{background-position:0px calc(100% - 5px);}}"], _theme_1.type.h2, _theme_1.palette.black, _theme_1.palette.ivory, _theme_1.palette.ivory, _theme_1.palette.ivory, _theme_1.palette.ivory, _theme_1.palette.ivory, _theme_1.palette.ivory, _theme_1.palette.ivory, _utils_1.mediaQuery('tablet'), _theme_1.gradient.textUnderline, Wrapper);
var Caption = styled_components_1.default.div.withConfig({
    displayName: "AlternatingImageLayout__Caption",
    componentId: "idkj2w-6"
})(["padding-top:7px;", " text-align:inherit;color:", ";transform:translate3d(0,0,0);transition:transform 1s ease-in-out;will-change:transform;", "{padding-top:8px;", ":hover &{transform:translate3d(4px,0,0);}}", "{padding-top:14px;}", "{padding-top:20px;}"], _theme_1.type.p, _theme_1.palette.ink, _utils_1.mediaQuery('tablet'), Wrapper, _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop')); // Button
var ButtonWrapper = styled_components_1.default.div.withConfig({
    displayName: "AlternatingImageLayout__ButtonWrapper",
    componentId: "idkj2w-7"
})(["display:flex;justify-content:center;padding-top:32px;transform:translate3d(0,0,0);transition:transform 1s ease-in-out;will-change:transform;", "{justify-content:flex-start;padding-top:40px;", ":hover &{transform:translate3d(0,-4px,0);}}", "{padding-top:48px;}", "{padding-top:64px;}"], _utils_1.mediaQuery('tablet'), Wrapper, _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var StyledButton = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, props);
}).withConfig({
    displayName: "AlternatingImageLayout__StyledButton",
    componentId: "idkj2w-8"
})(["", "{display:block;width:100%;}", "{", ":hover &{filter:contrast(120%);}}"], _utils_1.mediaQuery('tablet', 'max'), _utils_1.mediaQuery('tablet'), Wrapper); // Types
exports.default = AlternatingImageLayout;
